module.exports = __webpack_public_path__ + "img/icon-thermostat.dd8c3261.svg";